<template>
	<Dialog title="Ta bort senaste löneår" ref="dialog" :persistent="isDeleting" :width="600">
		<v-row dense justify="center">
			<v-col cols="12">
				<p>
					Borttag av senaste löneår bör endast utföras om det finns särskilda skäl och det rekommenderas att först tänka igenom eventuella konsekvenser.
				</p>
				<p>
					Framförallt är det viktigt om arbete redan påbörjats inom löneåret i form av till exempel lönebesked, arbetsgivardeklarationer, bokföringsunderlag, semesterberedningar, m.m. Exempelvis måste eventuella klarmarkerade lönebesked inom löneåret återföras innan löneåret kan tas bort.
				</p>
			</v-col>
			<v-col cols="12">
				<v-alert border="top" colored-border type="warning" elevation="1" class="ma-0 caption" dense>
					<b>Tänk på</b> att all information som tillhör det senaste löneåret kommer att försvinna för alltid. Det finns ingen möjlighet till att återställa informationen i efterhand. Däremot går det att skapa upp året på nytt med eventuella nya förutsättningar.
				</v-alert>
			</v-col>

			<v-col cols="12" v-if="!canDeleteYear">
				<v-alert border="top" colored-border type="error" elevation="1" class="ma-0 caption" dense>
					Företaget har endast ett löneår kvar och får ej tas bort.
				</v-alert>
			</v-col>
		</v-row>

		<template v-slot:buttons="{hide}">
			<v-btn color="secondary" @click="hide" :disabled="isDeleting">Avbryt</v-btn>
			<v-spacer></v-spacer>
			<v-btn color="error" @click="onConfirm" :disabled="!canDeleteYear" :loading="isDeleting">Ta bort löneår {{canDeleteYear ? yearToDelete : ''}}</v-btn>
		</template>
	</Dialog>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import Dialog                 from './Dialog.vue';
import SelectField            from './form/SelectField.vue';

export default {
	name: 'DeleteLatestSalaryYearDialog',

	data: () => ({
		isDeleting: false,
	}),

	methods: {
		...mapActions(['confirmDialog', 'refreshSalaryYears']),

		show() {
			this.$refs.dialog.show();
		},

		onConfirm() {
			this.confirmDialog({
				title:        'Ta bort senaste löneår',
				text:         `Är du helt säker på att du vill ta bort löneår <b>${this.yearToDelete}</b>? Åtgärden kan <b>inte</b> backas.`,
				cancelText:   'Avbryt',
				confirmText:  'Ja, ta bort',
				confirmColor: 'red',
				onConfirm:    () => {
					this.$tryCatch({
						task: async () => {
							this.isDeleting = true;

							await this.$http.delete(`/salaryyears/${encodeURIComponent(parseInt(this.yearToDelete, 10))}`);

							this.refreshSalaryYears();

							this.$msgSuccess('Löneåret har tagits bort.');

							this.$refs.dialog.hide();
						},

						finally: () => {
							this.isDeleting = false;
						},
					});
				},
			});
		},
	},

	computed: {
		...mapState(['SalaryYears']),

		yearToDelete() {
			return this.SalaryYears[0];
		},

		canDeleteYear() {
			return this.SalaryYears.length - 1 > 0;
		},
	},

	components: {SelectField, Dialog},
}
</script>

<style scoped>

</style>
